var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.lang.vcc)?_c('section',[_c('Title',{attrs:{"title-name":_vm.lang.vcc.SFS_LANG_ROW_7,"title-link":_vm.title.VirtualCreditCardDetail.titleLink}}),_c('div',{staticClass:"container",staticStyle:{"margin-top":"14pt"}},[_c('div',[_c('p',[_vm._v(_vm._s(_vm.lang.vcc.SFS_LANG_ROW_2))]),_c('CreditCard'),_c('p',[_vm._v(_vm._s(_vm.lang.vcc.SFS_LANG_ROW_3))]),_c('p',[_vm._v(_vm._s(_vm.lang.vcc.SFS_LANG_ROW_4))]),_c('p',[_vm._v(_vm._s(_vm.lang.vcc.SFS_LANG_ROW_5))]),_c('p',{domProps:{"innerHTML":_vm._s(
          _vm.replaceStr(
            _vm.lang.vcc.SFS_LANG_ROW_6,
            ['<amount>', '<currency>'],
            [_vm.VirtualCreditCardDetail.price_per_person, _vm.newcurrency]
          )
        )}})],1)])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }